import { render, staticRenderFns } from "./ControlePedidosPrintLayout.vue?vue&type=template&id=41c11188"
import script from "./ControlePedidosPrintLayout.vue?vue&type=script&lang=js"
export * from "./ControlePedidosPrintLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports